<template>
	<div class="tc_div_back">
		<el-dialog :visible.sync="loading" width="500px" class="tc_en" center id='text_color' :top='websta== "pc"?"17%":"30vh"' v-if="lan">
			<div v-text="$t('allpage.tishi')" slot='title' class="tc_title"></div>
			<div class="tc_centent">{{message}}</div>
			<!-- <div v-else style="font-size: 0.65rem !important; padding: 40px 50px;line-height: 1rem;" :class="mycenter?'my_left':'my_center'">{{message}}</div> -->
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="loading = false" class="tc_btn" style="padding: 13px 70px;border-radius: 30px;">
					{{$t('allpage.queding')}}
				</el-button>
				<div style="width: 100%;height: 1rem;"></div>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="loading" width="500px" class="tc_ch" center id='text_color' :top='websta== "pc"?"17%":"30vh"' v-else>
			<div v-text="$t('allpage.tishi')" slot='title'  class="tc_title"></div>
			<!-- <div v-if="lan" style="font-size: 0.65rem !important;word-break: break-word !important;padding: 40px 0;line-height: 1rem;">{{message}}</div> -->
			<div class="tc_centent" :class="mycenter?'my_left':'my_center'">{{message}}</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="loading = false" class="tc_btn" style="padding: 13px 70px;border-radius: 30px;">
					{{$t('allpage.queding')}}
				</el-button>
				<div style="width: 100%;height: 1rem;"></div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'messwarn',
		data() {
			return {
				websta : this.$store.state.onlinestate,
				lan: localStorage.lang == 'eng',
				mycenter:true,//文字对齐
				//状态
				loading: false,
				//提示文字
				message: '',
			}
		},
		methods: {
			SendMessage(message,mycenter=false) {
				this.message = message
				this.loading = true
				this.mycenter = mycenter
			},
		}
	}
</script>

<style lang="scss">

	.tc_div_back .el-dialog__body{
		background: #f0f7f0;
	}
	.tc_div_back .el-dialog__footer{
		background: #f0f7f0;
	}
	@media screen and (min-width:2200px){
		.tc_en .tc_title{
			font-size: 0.75rem !important;
			color: #fff;
			padding:10px;
		}
		.tc_en .tc_centent{
			font-size: 0.65rem !important;
			word-break: break-word !important;
			padding: 40px 0;
			line-height: 1rem;
		}
		
		.tc_ch .tc_title{
			font-size: 0.75rem !important;
			color: #fff;
			padding:10px;
		}
		.tc_ch .tc_centent{
			font-size: 0.65rem 	!important; 
			padding: 40px 50px;
			line-height: 1rem;
		}
		.tc_btn span{
			font-size: 18px !important;
		}

	}
		.tc_en .tc_title{
			font-size: 0.8rem;
			color: #fff;
			padding:10px;
		}
		.tc_en .tc_centent{
			font-size: 0.75rem ;
			word-break: break-word !important;
			padding: 40px 0;
			line-height: 1.1rem;
			display: flex;
			justify-content: center;
		}
		
		.tc_ch .tc_title{
			font-size: 0.8rem;
			color: #fff;
			padding:10px;
		}
		.tc_ch .tc_centent{
			font-size: 0.75rem; 
			padding: 40px 50px;
			line-height: 1.3rem;
		}
		
	

	#text_color {
		.my_center{
				text-align:center !important;
				
		}
		.my_left{
			text-align:left !important;
		}
		.el-button--primary {
			background-color: #3d7077 !important;
			border-color: #3d7077 !important;
			// width: 250px !important;
			// height: 50px !important;

			span {
				color: #fff !important;
				font-size: 0.75rem;
			}
			font {
				color: #fff !important;
			}
			.el-dialog__body {
				text-align: center !important;
			}
			
		}
		.el-icon-close:before{
			color: #fff;
		}
		.el-dialog--center{border-radius: 6px;}
		.el-dialog__footer{
			padding-bottom: 20px !important;
			padding-top: 0px !important;
		}
	}
	#mainView #text_color .el-dialog__header{
		background: #3d7077;
		border-radius: 6px 6px 0 0;
	}
	.el-dialog__headerbtn{
		font-size: 20px;
		top: 15px;
	}

</style>

